import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingIndicatorProps {
  message?: string;
  className?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ 
  message = "Loading...",
  className = "" 
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 p-8 ${className}`}>
      <Loader2 className="w-8 h-8 text-primary-400 animate-spin" />
      <p className="text-lg text-gray-300">{message}</p>
    </div>
  );
};

export default LoadingIndicator;
